import { $userLanguage } from '@/entities/user'
import { useStyles } from './styles'
import { useUnit } from 'effector-react'
import { lang } from '@/shared/constants/lang'
import { AppButton } from '@/shared/ui/button'
import { Icon } from '@/shared/ui/icon'
import { goToConnectPlatform, goToDailyBonus } from '@/app/routing/events'
import { $dailyBonusDay, $farcanaBonusStreak } from '@/entities/dailyBonus/model/store'
import { useGetFarcanaConnection } from '@/shared/hooks/useGetFarcanaConnection'
import { darkTheme } from '@/shared/styles/theme/dark'

export const DailyBonusPanel = ({ variant = 'default' }: { variant?: 'default' | 'farcana' }) => {
  if (variant === 'default') return <DefaultPanel />
  if (variant === 'farcana') return <FarcanaPanel />
}

function FarcanaPanel() {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const farcanaTexts = lang[userLang].pages.dailyBonus.farcana
  const btnTexts = lang[userLang].pages.btnTexts
  const farcanaStreak = useUnit($farcanaBonusStreak)
  const completedDays = Math.max(0, Math.min(14, farcanaStreak - 1))
  const isFarcanaConnected = useGetFarcanaConnection()
  return (
    <AppButton
      className={classes.root}
      onClick={() =>
        isFarcanaConnected ? goToDailyBonus({ variant: 'farcana' }) : goToConnectPlatform({ platform: 'farcana' })
      }
      style={{ width: '100%', background: darkTheme.colors.button.secondary.background }}
    >
      <div className={classes.topContainer}>
        <span className={classes.dailyRewardsText}>{farcanaTexts.panelHeading}</span>
        <div className={classes.receiveWrapper}>
          <Icon
            view="gift"
            style={{ filter: 'invert(1)', width: '20px' }}
          />
          <span>{btnTexts.receive}</span>
        </div>
      </div>
      <div className={classes.progressWrapper}>
        {new Array(14).fill(null).map((_, index) => (
          <div
            key={index}
            className={classes.dailyBonusProgressBlock}
            data-phase={setPhase(index, completedDays)}
          />
        ))}
      </div>
    </AppButton>
  )
}

function DefaultPanel() {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.dailyBonus.default
  const btnTexts = lang[userLang].pages.btnTexts
  const currentDay = useUnit($dailyBonusDay)
  const completedDays = Math.max(0, Math.min(7, currentDay - 1))
  return (
    <AppButton
      className={classes.root}
      onClick={() => goToDailyBonus({ variant: 'default' })}
    >
      <div className={classes.topContainer}>
        <span className={classes.dailyRewardsText}>{texts.dailyRewards}</span>
        <div className={classes.receiveWrapper}>
          <Icon
            view="gift"
            style={{ filter: 'invert(1)', width: '20px' }}
          />
          <span>{btnTexts.receive}</span>
        </div>
      </div>
      <div className={classes.progressWrapper}>
        {new Array(7).fill(null).map((_, index) => (
          <div
            key={index}
            className={classes.dailyBonusProgressBlock}
            data-phase={setPhase(index, completedDays)}
          />
        ))}
      </div>
    </AppButton>
  )
}

const setPhase = (index: number, completedDays: number) => {
  if (index === completedDays) {
    return 'currentDay'
  }
  if (index < completedDays) {
    return 'prevDay'
  }
  return 'nextDay'
}
